import "core-js/modules/es.symbol";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react"; // eslint-disable-next-line css-modules/no-unused-class

import Button from "web/react/components/button/button";
import styles from "./social-button.css";
var TYPE_CLASSES = {
  facebook: styles.facebook,
  google: styles.google
};
export default function SocialButton(_ref) {
  var className = _ref.className,
      type = _ref.type,
      props = _objectWithoutProperties(_ref, ["className", "type"]);

  var typeClass = TYPE_CLASSES[type];

  if (!typeClass) {
    throw new Error("Unknown type ".concat(type, "!"));
  }

  return React.createElement(Button, _extends({
    className: classnames(className, typeClass),
    styleType: "primary"
  }, props));
}
SocialButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(["facebook", "google"]).isRequired
};